/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_No_DeckInputs */



/**
* | output |
* | --- |
* | "the winner has no deck on file" |
*
* @param {Twda_Reason_No_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_no_deck = /** @type {((inputs?: Twda_Reason_No_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_No_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("le vainqueur n'a pas de deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("el ganador no tiene mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o vencedor não tem deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("il vincitore non ha un mazzo")
	return /** @type {LocalizedString} */ ("the winner has no deck on file")
});